import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './scrollSidebar.css'

import { injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
// import { Link } from 'react-router-dom'
import { MenuButton } from '../../common/elements/buttons'
import { ScrollPageChild } from '../../common/scrollpage'
import { Portal } from 'react-portal'
import { Menu } from '../../common/header/menu'
import { ContentChapter } from '../storydocStoreContent'
// import bind from 'bind-decorator'

interface ISideBar {
  chapter?: ContentChapter
}

@injectStores
@observer
export class ScrollSidebar extends ScrollPageChild<ISideBar> {

  @observable isHover = false
  @observable scrollPosition = 0
  scrollElement: HTMLDivElement | null = null

  componentDidUpdate () {
    if (this.props.scrollerData && this.props.chapter && this.store.storyDocUI.currentSlideIdx === this.props.chapter.idx) {
      this.store.storeCommon.currentStory.scrollerData = Object.assign([], this.props.scrollerData)
    }

  }

  render () {
    // console.log('scroll sidebar props', this.props)
    let menu: JSX.Element | null = null
    menu = <Portal> <Menu /> </Portal>

    const bars = []

    if (!this.props.chapter) {
      return null
    }

    for (let i = 0; i < this.props.chapter.sections.length; i++) {
      let fillerHeight = 0

      let isCurrent = false

      // first scrollerData is the cover
      if (this.props.scrollerData) {
        fillerHeight = Math.max(Math.min(this.props.scrollerData[i + 1], 1.0), 0.0) * 100
        isCurrent = this.props.scrollerData[i + 1] >= 0 && this.props.scrollerData[i + 1] < 1
      }

      let sectionTitle = this.props.chapter.idx > 0 ? `${ this.props.chapter.idx }.${ i + 1 } ` + this.props.chapter.sections[i].title.replace(/–/g, '-<br>') : ''

      bars.push(<div
        // to={`/story/${this.props.chapter.idx}#${this.props.chapter.sections[i].id}`}
        key={this.props.chapter.sections[i].id}
        className={styles.barItem}
        onMouseEnter={() => this.isHover = true}
        onMouseLeave={() => this.isHover = false}
        onClick={() => {
          if (this.props.scrollerRefs && this.props.scrollerRefs[i]) {
            this.props.scrollerRefs[i + 1].scrollIntoView()
          }
        }}
      >
        <div className={ styles.filler } style={{ height: `${fillerHeight}%` }}></div>
        { this.store.breakpoints.desktop &&
          <div className={classnames(styles.text, this.isHover ? styles.otherHover : null, isCurrent ? styles.currentSectionText : null) } dangerouslySetInnerHTML={{ __html: sectionTitle }}>
          </div>
        }
        <div className={ styles.border } style={ i === 0 && this.store.breakpoints.phone ? { opacity: 0 } : undefined }></div>
      </div>
      )
    }

    let burger: JSX.Element | null = null
    if (this.store.breakpoints.desktop) {
      burger = <div className={ styles.burger } onClick={ () => this.store.storeCommon.menu.open = !this.store.storeCommon.menu.open }>
                  <MenuButton />
                </div>
    }

    // cover page
    // console.log('scroller data before y', this.props.scrollerData)
    let y = Math.min(2, (this.props.scrollerData ? this.props.scrollerData[0] : 1))
    y = (2.0 - y) * this.store.storeCommon.window.height

    let height = this.store.storeCommon.window.height
    if (this.store.breakpoints.phone) {
      height = this.store.storeCommon.window.height - 50
    }

    return (
      <div className={styles.scrollSidebar} style={{ transform: `translateY(${y}px)`, height: height }}>
        { bars }
        { burger }
        {this.store.breakpoints.desktop && <div className={styles.kapitel}>{this.props.chapter.idx > 0 ? this.props.chapter.title : 'Intro'}</div>}
        {menu}
      </div >
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/book/scrollSidebar.tsx